module.exports = "<p>\n  fireleasedates works!\n</p>\n"